import React from 'react';
import { FormattedMessage } from 'react-intl';
import { OptionFormTypes } from '../../../../../services/filtering/filter-form-render-service/option-form-types';
import { messages } from '../messages';
import { noop } from 'ui-components/default-props/noop';

export const International = {
  id: 'international',
  displayName: <FormattedMessage {...messages.international} />,
  type: OptionFormTypes.TYPE_BOOLEAN,
  filterValue: 'IsInternational',
  render: noop,
};
